import { Injectable, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { SUFIJO_TITULO } from './servicios/origen.service';

/**
 * El `title` de la ruta va a la pestaña del navegador como "Luminarias · IRIX".
 * Es también el nombre de la página en las migas de la siguiente (lo lee
 * `OrigenService`), salvo en los detalles, que se nombran con la entidad.
 */
@Injectable({ providedIn: 'root' })
export class TituloPagina extends TitleStrategy {
  private readonly title = inject(Title);

  override updateTitle(snapshot: RouterStateSnapshot): void {
    const titulo = this.buildTitle(snapshot);
    this.title.setTitle(titulo ? `${titulo}${SUFIJO_TITULO}` : 'IRIX');
  }
}
